export const issueRptConstants ={
    GETALL_REQUEST: 'ISSUERPT_GETALL_REQUEST',
    GETALL_SUCCESS: 'ISSUERPT_GETALL_SUCCESS',
    GETALL_FAILURE: 'ISSUERPT_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'ISSUERPT_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'ISSUERPT_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'ISSUERPT_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}